module.exports = __webpack_public_path__ + "static/img/code_new.a5f282b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code_new.png
// module id = BZvD
// module chunks = 128